import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import FrSpeechBubbleSvg from '@src/svgs/fr-speech-bubble.svg';
import { FollowUpProps } from './props';
import './styles.scss';

export const FollowUp: FC<FollowUpProps> = ({ onFollowUp }) => {
  return (
    <div
      className="featured-applicant-follow-up"
      onClick={event => {
        event.stopPropagation();
        onFollowUp();
      }}
    >
      <Svg className="featured-applicant-follow-up__action-icon" src={FrSpeechBubbleSvg} />
      Follow up
    </div>
  );
};
